import { BackAuthEntitiesFeatureKey, BackAuthEntitiesInitialState, IBackAuthEntitiesState } from './entities/entities.state';
import { BackAuthUsersFeatureKey, BackAuthUsersInitialState, IBackAuthUsersState } from './users/users.state';

export const BackAuthFeatureKey = 'auth';

export interface IBackAuthState
{
    [BackAuthEntitiesFeatureKey]: IBackAuthEntitiesState;
    [BackAuthUsersFeatureKey]: IBackAuthUsersState;
}
export const BackAuthInitialState: IBackAuthState =
{
    [BackAuthEntitiesFeatureKey]: BackAuthEntitiesInitialState,
    [BackAuthUsersFeatureKey]: BackAuthUsersInitialState
};
